import {
  FaBroadcastTower, FaTv, FaCog, FaFileAlt, FaChartLine,
} from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import NavItem from './navItem';
import IconDashboard from '../images/ic_dashboard.png';
// import IconRoyalties from '../images/ic_royalties.png';
import IconWriters from '../images/ic_writers.png';
import IconSongs from '../images/ic_songs.png';
import IconGigs from '../images/ic_gigs.png';
import IconOpportunities from '../images/ic_opportunities.png';

const IconSyncs = (
  <FaTv />
);

const IconBroadcasts = (
  <FaBroadcastTower />
);

const IconSettings = (
  <FaCog />
);

const IconStatements = (
  <FaFileAlt />
);
const IconRoyalties = (
  <FaChartLine />
);

function NavItems(props) {
  const { t } = useTranslation('other');
  const {
    highlightColour, darkColour, enableOpportunities, enableSyncs, enableStatements, enableRoyalties,
  } = props;

  return (
    <>
      <NavItem
        exact
        to="/"
        title={t('other:nav-dashboard')}
        highlightColour={highlightColour}
        darkColour={darkColour}
        icon={IconDashboard}
      />
      {/* <NavItem
    to="/royalties"
    title="Royalties"
    highlightColour={highlightColour}
    darkColour={darkColour}
    icon={IconRoyalties}
  /> */}
      <NavItem
        to="/writers"
        title={t('other:nav-writers')}
        highlightColour={highlightColour}
        darkColour={darkColour}
        icon={IconWriters}
      />
      <NavItem
        to="/songs"
        title={t('other:nav-songs')}
        highlightColour={highlightColour}
        darkColour={darkColour}
        icon={IconSongs}
      />

      <NavItem
        to="/gigs"
        title={t('other:nav-gigs')}
        highlightColour={highlightColour}
        darkColour={darkColour}
        icon={IconGigs}
      />
      {!!enableOpportunities
      && (
      <NavItem
        to="/opportunities"
        title={t('other:nav-opportunities')}
        highlightColour={highlightColour}
        darkColour={darkColour}
        icon={IconOpportunities}
      />
      )}
      {!!enableSyncs
      && (
      <NavItem
        to="/syncs"
        title={t('other:nav-syncs')}
        highlightColour={highlightColour}
        darkColour={darkColour}
        icon={IconSyncs}
        iconIsFA
      />
      )}
      {!!enableRoyalties
      && (
      <NavItem
        to="/royalties"
        title={t('other:nav-royalties')}
        highlightColour={highlightColour}
        darkColour={darkColour}
        icon={IconRoyalties}
        iconIsFA
      />
      )}

      {!!enableStatements
      && (
      <NavItem
        lighterBackground
        to="/statements"
        title={t('other:nav-statements')}
        highlightColour={highlightColour}
        darkColour={darkColour}
        icon={IconStatements}
        iconIsFA
      />
      )}

      <NavItem
        to="/broadcasts"
        title={t('other:nav-broadcasts')}
        highlightColour={highlightColour}
        darkColour={darkColour}
        icon={IconBroadcasts}
        iconIsFA
      />

      <NavItem
        lighterBackground
        to="/settings"
        title={t('other:nav-settings')}
        highlightColour={highlightColour}
        darkColour={darkColour}
        icon={IconSettings}
        iconIsFA
      />
    </>
  );
}

export default NavItems;
